import { render, staticRenderFns } from "./TapestryScoresByCivilization.vue?vue&type=template&id=42314c9e"
import script from "./TapestryScoresByCivilization.vue?vue&type=script&lang=ts"
export * from "./TapestryScoresByCivilization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports